import Vue from 'vue';
import * as featherIcons from 'vue-feather-icons';

Object.entries(featherIcons).forEach(([icon]) => {
  Vue.component(icon, featherIcons[icon]);
});
